import { updateObject } from '../Utility';
import {
  POLLS_QUESTIONS_GET_START,
  POLLS_QUESTIONS_GET_SUCCESS,
  POLLS_QUESTIONS_GET_FAIL,
  POLLS_VOTE_POST_START,
  POLLS_VOTE_POST_SUCCESS,
  POLLS_VOTE_POST_FAIL,
  POLLS_FILTERED_GET_START,
  POLLS_FILTERED_GET_SUCCESS,
  POLLS_FILTERED_GET_FAIL
} from '../actions/PollsActions';

const initialState = {
  items: {},
  latest: null,
  loading: false,
  fetched: false,
  error: null,
  filtered: {
    items: [],
    pagination: {
      count: 0,
      next: null,
      page: 1,
      page_size: 20,
      previous: null
    },
    loading: false,
    error: null
  }
};

// GET:
const getPollsQuestionsStart = (state, action) => updateObject(state, {
  ...state,
  loading: true,
  error: null
});

const getPollsQuestionsSuccess = (state, action) => updateObject(state, {
  ...state,
  items: action.questions.reduce((obj, question) => {
    obj[question.id] = question;
    obj[question.id].choices = question.choices.reduce((obj, choice) => {
      obj[choice.id] = choice;
      return obj;
    }, {});
    return obj;
  }, {}),
  latest: action.latest,
  loading: false,
  fetched: true
});

const getPollsQuestionsFail = (state, action) => updateObject(state, {
  ...state,
  loading: false,
  error: action.error
});

// POST:
const postPollsVoteStart = (state, action) => updateObject(state, {
  ...state,
  loading: true,
  error: null
});

const postPollsVoteSuccess = (state, action) => updateObject(state, {
  ...state,
  items: {
    ...state.items,
    [action.vote.question_id]: {
      ...state.items[action.vote.question_id],
      votes_count: state.items[action.vote.question_id].votes_count + 1,
      choices: {
        ...state.items[action.vote.question_id].choices,
        [action.vote.choice_id]: {
          ...state.items[action.vote.question_id].choices[
            action.vote.choice_id
          ],
          votes_count:
              state.items[action.vote.question_id].choices[
                action.vote.choice_id
              ].votes_count + 1
        }
      }
    }
  },
  loading: false
});

const postPollsVoteFail = (state, action) => updateObject(state, {
  ...state,
  loading: false,
  error: action.error
});

// GET FILTERED:
const getFilteredPollsStart = (state, action) => updateObject(state, {
  ...state,
  filtered: {
    ...state.filtered,
    loading: true,
    error: null
  }
});

const getFilteredPollsSuccess = (state, action) => {
  const incomingItems = Array.isArray(action.filteredPolls)
    ? action.filteredPolls
    : [];

  const mergedItems = action.append
    ? [
      ...state.filtered.items,
      ...incomingItems.filter(
        (item) => item && !state.filtered.items.some((existing) => existing.id === item.id)
      )
    ]
    : incomingItems;

  return updateObject(state, {
    ...state,
    filtered: {
      items: mergedItems,
      loading: false,
      error: null,
      pagination: {
        count: Number(action.pagination?.count || 0),
        next: action.pagination?.next || null,
        page: Number(action.pagination?.page || 1),
        page_size: Number(action.pagination?.page_size || 20),
        previous: action.pagination?.previous || null
      }
    }
  });
};

const getFilteredPollsFail = (state, action) => updateObject(state, {
  ...state,
  filtered: {
    ...state.filtered,
    loading: false,
    error: action.error
  }
});

const PollsReducer = (state = initialState, action) => {
  switch (action.type) {
    // POLLS QUESTIONS GET
    case POLLS_QUESTIONS_GET_START:
      return getPollsQuestionsStart(state, action);
    case POLLS_QUESTIONS_GET_SUCCESS:
      return getPollsQuestionsSuccess(state, action);
    case POLLS_QUESTIONS_GET_FAIL:
      return getPollsQuestionsFail(state, action);

    // POLLS VOTE POST
    case POLLS_VOTE_POST_START:
      return postPollsVoteStart(state, action);
    case POLLS_VOTE_POST_SUCCESS:
      return postPollsVoteSuccess(state, action);
    case POLLS_VOTE_POST_FAIL:
      return postPollsVoteFail(state, action);

    // POLLS FILTERED GET
    case POLLS_FILTERED_GET_START:
      return getFilteredPollsStart(state, action);
    case POLLS_FILTERED_GET_SUCCESS:
      return getFilteredPollsSuccess(state, action);
    case POLLS_FILTERED_GET_FAIL:
      return getFilteredPollsFail(state, action);

    default:
      return state;
  }
};

export default PollsReducer;
